










































































import { Component, Mixins, Prop, Emit } from "vue-property-decorator";
import AxiosMixin from "@/mixins/axiosMixin";
import PatientInfo from "@/components/patient/PatientInfo.vue";
import UtilMixin from "@/mixins/utilMixin";
import { VForm } from "@/types";
import PatientMixin from "@/mixins/patientMixin";
import { Link } from "#/types";
import ExpantionActions from "./ExpantionActions.vue";

@Component({
  components: {
    PatientInfo,
    ExpantionActions
  }
})
export default class PatientExpantionAreas extends Mixins(
  AxiosMixin,
  UtilMixin,
  PatientMixin
) {
  /** Prop */

  /** ヘッダー(未使用) */
  @Prop() header!: HTMLElement;

  /** ページ内リンク設定 */
  @Prop({ default: () => [] }) links!: Link[];

  /** サイドバー非表示フラグ */
  @Prop({ default: false }) isHideSideBar!: boolean;

  /** Emit */

  @Emit("update:links")
  updateLinks(newValue: Link[]) {
    return newValue;
  }

  // リンク
  private get SelectLinks(): Link[] {
    const selectLinks = [];
    for (let index = 0; index < this.links.length; index++) {
      const link = this.links[index];
      if (this.keyOpenTargeIndexes.findIndex(v => v === link.key) === -1) {
        this.keyOpenTargeIndexes.push(link.key);
      }

      const targetIndex = this.keyOpenTargeIndexes.findIndex(
        v => v === link.key
      );
      const num = this.openedPanels.findIndex(v => {
        return v === targetIndex;
      });
      if (num > -1) {
        link.is_select = true;
      } else {
        link.is_select = false;
      }
      selectLinks.push(link);
    }
    return selectLinks;
  }

  /** キーに対応するインデックス(Vuetifyのバグでlink配列のindexとvalueの指定indexが異なるため、ここでkeyに対応する指定indexを保持しておく) */
  private keyOpenTargeIndexes: string[] = [];

  /** パネル展開状態 */
  private openedPanels: number[] = this.links
    .filter(link => link.is_select)
    .map((l, i) => i);

  // パネル展開
  private open(_: number, key: string) {
    let scrollDelay = 1;
    const keyIdx = this.keyOpenTargeIndexes.findIndex(v => v === key);
    if (
      this.openedPanels.findIndex(panelIndex => panelIndex === keyIdx) == -1
    ) {
      this.openedPanels.push(keyIdx);
      scrollDelay = 400;
    }
    setTimeout(() => {
      const ele = document.getElementById(key);
      const topPos = ele?.offsetTop ?? 0;
      window.scrollTo(0, topPos);
    }, scrollDelay);
  }

  //バリデーションチェック
  public validate(): boolean {
    let ok = true;
    const newLink: Link[] = [];
    for (const link of this.links) {
      const refs = this.$refs[link.key] as unknown[];
      const ref = refs[0] as VForm;
      if (!ref.validate()) {
        ok = false;
        link.is_false = true;
        newLink.push(link);
      } else {
        link.is_false = false;
        newLink.push(link);
      }
    }
    //その他エリアチェック
    if (this.$scopedSlots["others"]) {
      const ref = (this.$refs.others as unknown) as VForm;
      if (!ref.validate()) {
        ok = false;
      }
    }
    //先頭エリアチェック
    if (this.$scopedSlots["tops"]) {
      const ref = (this.$refs.tops as unknown) as VForm;
      if (!ref.validate()) {
        ok = false;
      }
    }
    this.updateLinks(newLink);
    return ok;
  }

  //バリデーションリセット（書類保存時に使用）
  public resetValidation() {
    for (const link of this.links) {
      const refs = this.$refs[link.key] as unknown[];
      const ref = refs[0] as VForm;
      ref.resetValidation();
    }

    //その他エリア
    const refOthers = (this.$refs.others as unknown) as VForm | undefined;
    refOthers?.resetValidation();

    //先頭エリア
    const refTops = (this.$refs.tops as unknown) as VForm | undefined;
    refTops?.resetValidation();

    return;
  }
}
